import { ViewConfigState } from './viewConfigSlice';

export const DEFAULT_VIEW_CONFIG_STATE: ViewConfigState = {
  viewportsToShowBorder: [],
  recentlySelected: [],
};

export const MAX_RECENTLY_SELECTED_VIEWS = 4;
